import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerTitle,
} from '../../../../design-system/drawer/drawer';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';
import { AccountView, CardView } from '../../../../types/entity-types';
import { CreateVirtualCardRequest, useCreateCard } from '../../hooks/use-create-card';
import { CardPreview } from '../card-preview/card-preview';
import { CreateCardForm } from './create-card-form';

type CardCreationDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (card: CardView) => void;
  onViewCard: (card: CardView) => void;
  accounts: AccountView[];
  firstName?: string;
  lastName?: string;
};

export const CardCreationDrawer = ({
  isOpen,
  onClose,
  onSuccess,
  onViewCard,
  accounts,
  firstName,
  lastName,
}: CardCreationDrawerProps) => {
  const { createCard, isCreating } = useCreateCard({ onViewCard });

  const handleSubmit = async (data: CreateVirtualCardRequest) => {
    try {
      const card = await createCard(data);
      if (card) {
        onSuccess(card);
        onClose();
      }
    } catch {
      // Error is handled in useCreateCard hook
    }
  };

  const cardholderName = [firstName, lastName].filter(Boolean).join(' ');

  return (
    <Drawer open={isOpen} onOpenChange={(open) => !open && onClose()} direction="right">
      <DrawerOverlay className="bg-foreground/20" />
      <DrawerContent
        className="fixed top-4 right-4 bottom-4 h-auto w-[440px] overflow-hidden rounded-2xl bg-card p-0 shadow-2xl outline-none data-[vaul-drawer-direction=right]:min-w-[440px] data-[vaul-drawer-direction=right]:sm:max-w-[440px]"
        aria-describedby={undefined}
      >
        <Stack space={0} align="stretch" className="h-full">
          <DrawerHeader className="relative bg-card p-0">
            <div className="px-8 py-6">
              <Inline align="center" justify="between">
                <DrawerTitle className="text-xl font-semibold text-foreground">Create a card</DrawerTitle>
                <DrawerClose className="static top-auto right-auto text-muted-foreground hover:text-foreground" />
              </Inline>
            </div>

            <div className="h-px w-full bg-border" />
          </DrawerHeader>

          <div className="flex-1 overflow-hidden">
            <CreateCardForm accounts={accounts} onSubmit={handleSubmit} onCancel={onClose} isSubmitting={isCreating}>
              <CardPreview cardholderName={cardholderName} />
            </CreateCardForm>
          </div>
        </Stack>
      </DrawerContent>
    </Drawer>
  );
};
